import { UPDATE_EXIT_COUNT } from "../actions/UpdateExitCount";

const initialState = {
  exitCount: 0,
};

const exitReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_EXIT_COUNT:
      return {
        ...state,
        exitCount: action.payload,
      };
    default:
      return state;
  }
};

export default exitReducer;